import React from "react";
import "./../Pages/about-us.css";
import { VscCoffee } from "react-icons/vsc";
import StatsCounter from "../components/StatsCounter";
import PromoSection from "../components/PromoSection";
// import GallerySection from './../components/GallerySection'
import BreadcrumbBanner from "../components/BreadcrumbBanner";
import SeoHelmet from "../Seo/SeoHelmet";

const AboutUs = () => {
  return (
    <div>
      <SeoHelmet page="about" />
      <BreadcrumbBanner
        title="About Us"
        backgroundImage="/Images/banner-about.jpg"
      />

      <section className="about-section"> 
        <img
          src="/Images/best food in mandurah.webp" 
          alt="left decoration"
          className="decor decor-left"
        />

        <img
          src="/Images/chicken chilli rice in mandurah.webp"
          alt="right decoration"
          className="decor decor-right"
        />

        <div className="about-content">
          <p className="subtitle">— ABOUT RESTAURANT —</p>
          <h2>
            ENJOY AN EXCEPTIONAL
            <br />
            JOURNEY OF TASTE
          </h2>

          <p className="para-small">
            Every cup at Mandurah Cafe is made with carefully chosen beans and
            brewed to perfection. Our baristas do more than just serve coffee;
            they create experiences, one cup at a time. From Indo-Chinese,North
            Indian, South Indian food to Aussie breakfast, you will get all your
            favourite bites under one roof.
          </p>

          <p className="para-normal">
            Authentic Indian flavours, aussie breakfast treat, warm hospitality
            and cozy cafe vibe make every visit a memorable one. Join this
            exceptional journey of taste with us and let your taste buds travel.
          </p>

          {/* <button className="book-btn">BOOK NOW</button> */}
        </div>
      </section>

      <StatsCounter />
      <PromoSection />

      <section className="mission-section">
        <div className="mission-container">
          <div className="mission-text">
            <p className="small-heading">
              <VscCoffee /> Our Approach
            </p>
            <h2 className="section-title">
              Crafting the Perfect Coffee Experience
            </h2>

            <div className="mission-block">
              <img
                src="/Images/about-mission-icon.png"
                alt="mission"
                className="icon"
              />
              <div>
                <h3>Our Mission</h3>
                <p>
                  Our mission is to serve authentic Indian flavors to your
                  plate. Our goal is to create a place where tradition meets
                  with taste, and every dish becomes a memory.
                </p>
              </div>
            </div>

            <hr />

            <div className="mission-block">
              <img
                src="/Images/about-mission-icon.png"
                alt="vision"
                className="icon"
              />
              <div>
                <h3>Our Vision</h3>
                <p>
                  Our vision is to build a cafe experience that delights
                  everyone.
                </p>
              </div>
            </div>

            <hr />

            <div className="mission-block">
              <img
                src="/Images/about-mission-icon.png"
                alt="value"
                className="icon"
              />
              <div>
                <h3>Our Value</h3>
                <p>
                  Our values are staying true to the roots of Indian cuisine,
                  focusing on quality first and excellence in every single dish.
                </p>
              </div>
            </div>
          </div>

          <div className="mission-image">
            <img src="/Images/best-cafe-mandurah.webp" alt="coffee" />
          </div>
        </div>
      </section>

      {/* <GallerySection/> */}
    </div>
  );
};

export default AboutUs;
